module.exports = __webpack_public_path__ + "img/165.6ee7acb7.jpg";